import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Language } from './Language';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-language-modal-update',
  templateUrl: './language-modal-update.component.html'
})
export class LanguageModalUpdateComponent extends BaseModalUpdateComponent<Language> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Language>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
